export const TabsSuggestionData = [
       'LN', '/LN', 'FIL', '/FIL', 'MB', '/MB', 'NOISE', '/NOISE', 'ADULT', '/ADULT', 'SIL', '/SIL'
];
